module.exports = __webpack_public_path__ + "media/images/city_img/v-1b703b0336736a823c0165fdde10b583.png";